var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_850_3436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4872 5.60039C17.4872 5.60039 17.3211 4.42832 16.8098 3.91367C16.1624 3.23633 15.4385 3.23301 15.1065 3.19316C12.7292 3.02051 9.15981 3.02051 9.15981 3.02051H9.15317C9.15317 3.02051 5.58384 3.02051 3.20649 3.19316C2.87446 3.23301 2.15063 3.23633 1.50317 3.91367C0.991846 4.42832 0.82915 5.60039 0.82915 5.60039C0.82915 5.60039 0.656494 6.97832 0.656494 8.35293V9.64121C0.656494 11.0158 0.82583 12.3938 0.82583 12.3938C0.82583 12.3938 0.991846 13.5658 1.49985 14.0805C2.14731 14.7578 2.99731 14.7346 3.37583 14.8076C4.73716 14.9371 9.15649 14.977 9.15649 14.977C9.15649 14.977 12.7292 14.9703 15.1065 14.801C15.4385 14.7611 16.1624 14.7578 16.8098 14.0805C17.3211 13.5658 17.4872 12.3938 17.4872 12.3938C17.4872 12.3938 17.6565 11.0191 17.6565 9.64121V8.35293C17.6565 6.97832 17.4872 5.60039 17.4872 5.60039ZM7.40005 11.2051V6.42715L11.992 8.82441L7.40005 11.2051Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_850_3436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(0.656494 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.229a57770d25d591d3400b9427fa19a9.svg";
export { ForwardRef as ReactComponent };